import React, { useState } from 'react';
import ReactGA from 'react-ga';
import LockPage from './LockPage';
import MainPage from './MainPage';

import './App.css';

const App = () => {
  const [selectedLock, setSelectedLock] = useState(0);

  const setAndTrackLock = (lock: number) => {
    ReactGA.event({
      category: 'Puzzle',
      action: 'Set Lock',
      value: lock
    });
    return setSelectedLock(lock);
  };

  if (selectedLock) {
    return (
      <div className="App">
        <LockPage lock={selectedLock} onBack={() => setAndTrackLock(0)} />
      </div>
    );
  }

  return (
    <div className="App">
      <MainPage setSelectedLock={(sl: number) => setAndTrackLock(sl)} />
    </div>
  );
};

export default App;
